/**
 * @generated SignedSource<<8185485098d85bc0b053b1d680820f7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type PolicyCollectionPickerRefetchQuery$variables = {
  first?: number | null | undefined;
  policyCollectionFilterElement?: FilterElementInput | null | undefined;
};
export type PolicyCollectionPickerRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PolicyCollectionPicker_policyCollections">;
};
export type PolicyCollectionPickerRefetchQuery = {
  response: PolicyCollectionPickerRefetchQuery$data;
  variables: PolicyCollectionPickerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "policyCollectionFilterElement"
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PolicyCollectionPickerRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PolicyCollectionPicker_policyCollections"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PolicyCollectionPickerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filterElement",
            "variableName": "policyCollectionFilterElement"
          },
          (v1/*: any*/)
        ],
        "concreteType": "PolicyCollectionConnection",
        "kind": "LinkedField",
        "name": "policyCollections",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PolicyCollection",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userPermissions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleAssignmentTarget",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "027c9332efc8638264764f1d17822a93",
    "id": null,
    "metadata": {},
    "name": "PolicyCollectionPickerRefetchQuery",
    "operationKind": "query",
    "text": "query PolicyCollectionPickerRefetchQuery(\n  $first: Int = 1000\n  $policyCollectionFilterElement: FilterElementInput\n) {\n  ...PolicyCollectionPicker_policyCollections_3ASum4\n}\n\nfragment PolicyCollectionPicker_policyCollections_3ASum4 on Query {\n  policyCollections(filterElement: $policyCollectionFilterElement, first: $first) {\n    edges {\n      node {\n        name\n        uuid\n        userPermissions\n        roleAssignmentTarget\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "50103250137edd47f8f134adb50215f0";

export default node;
